// config.js

const phpPath = "https://eleven.fit/php";

export { phpPath };